<template>
  <div>
    <menusuperior titulo="THEMIS" subtitulo="Poder Judicial del Estado de Aguascalientes"></menusuperior>
    <menuizquierda></menuizquierda>


    <transition id="contenidoDeLosSistemas" name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

  </div>
</template>

<script>
  import menusuperior from '../Comunes/MenuSuperior.vue'
  import menuizquierda from '../Tablero/MenuIzquierda.vue'
  import comun from '@/../static/js/comun'

  export default {
    components: {
      menusuperior,
      menuizquierda
    }
  }

</script>

<style>
  #cards {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 20px;
  }

    #cards h1 {
      font-size: 40px;
      font-weight: bold;
      background: linear-gradient(#45454c, #363638);
      width: 120px;
      height: 120px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .5s;
    }

    #cards h2 {
      margin-top: 15px;
      font-size: 20px;
      width: 100%;
    }

    #cards a {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      color: #FFF;
      width: 20%;
      border: 1px solid #222222;
      padding-top: 10px;
    }

      #cards a:hover {
        text-decoration: none;
        background-color: rgba(255,255,255,0.2);
        border: 1px solid #AAA;
        box-sizing: border-box;
      }

        #cards a:hover h1 {
        }
</style>



// WEBPACK FOOTER //
// src/components/Tablero/Plantilla.vue